import { useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import "./AdminLayout.css";

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // =========================================================
  // MENU ADMIN
  // =========================================================

  const menuItems = [
    {
      label: "Dashboard",
      path: "/dashboard-admin",
      icon: "🏠",
    },
    {
      label: "Data Siswa",
      path: "/data-siswa",
      icon: "👨‍🎓",
    },
    {
      label: "Data Tentor",
      path: "/data-tentor",
      icon: "👨‍🏫",
    },
    {
      label: "Kelas",
      path: "/kelas",
      icon: "📚",
    },
    {
      label: "Pembayaran",
      path: "/pembayaran",
      icon: "💳",
    },
    {
      label: "Absensi",
      path: "/absensi",
      icon: "✅",
    },
    {
      label: "Nilai",
      path: "/nilai",
      icon: "📊",
    },
    {
      label: "Jadwal",
      path: "/jadwal",
      icon: "📅",
    },
    {
      label: "Pengumuman",
      path: "/pengumuman",
      icon: "📢",
    },
    {
      label: "Kelola Admin",
      path: "/KelolaAdmin",
      icon: "⚙️",
    },
    {
      label: "Log Aktivitas",
      path: "/log-aktivitas",
      icon: "📝",
    },
  ];

  // =========================================================
  // MENU AKTIF
  // =========================================================

  const isActive = (path) => {
    return location.pathname === path;
  };

  // =========================================================
  // NAVIGASI
  // =========================================================

  const handleNavigation = (path) => {
    navigate(path);

    // Tutup drawer setelah memilih menu
    setIsMenuOpen(false);
  };

  // =========================================================
  // LOGOUT
  // =========================================================

  const handleLogout = () => {
    const yakin = window.confirm("Apakah Anda yakin ingin keluar?");

    if (!yakin) return;

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");

    setIsMenuOpen(false);

    navigate("/login", {
      replace: true,
    });
  };

  // =========================================================
  // TOGGLE MENU
  // =========================================================

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div className="admin-layout">
      {/* =====================================================
          MOBILE OVERLAY
      ===================================================== */}

      <div
        className={`admin-mobile-overlay ${isMenuOpen ? "show" : ""}`}
        onClick={closeMenu}
      ></div>

      {/* =====================================================
          DESKTOP SIDEBAR / MOBILE DRAWER
      ===================================================== */}

      <aside className={`admin-sidebar ${isMenuOpen ? "mobile-open" : ""}`}>
        {/* ===================================================
            HEADER SIDEBAR
        =================================================== */}

        <div className="admin-sidebar-header">
          <div className="sidebar-logos">
            <span>BIMBELKU</span>
            <small>TIGABINANGA</small>
          </div>

          {/* Tombol close mobile */}

          <button
            className="admin-mobile-close"
            onClick={closeMenu}
            aria-label="Tutup menu"
          >
            ✕
          </button>
        </div>

        {/* ===================================================
            MENU
        =================================================== */}

        <nav className="admin-navigation">
          <ul>
            {menuItems.map((item) => (
              <li
                key={item.path}
                className={isActive(item.path) ? "active" : ""}
                onClick={() => handleNavigation(item.path)}
              >
                <span className="admin-menu-icon">{item.icon}</span>

                <span className="menu-dot"></span>

                <span className="menu-label">{item.label}</span>
              </li>
            ))}

            {/* =================================================
                LOGOUT
            ================================================= */}

            <li className="logout-menu" onClick={handleLogout}>
              <span className="admin-menu-icon">🚪</span>

              <span className="menu-dot"></span>

              <span className="menu-label">Log Out</span>
            </li>
          </ul>
        </nav>
      </aside>

      {/* =====================================================
          MOBILE TOPBAR
      ===================================================== */}

      <header className="admin-mobile-topbar">
        <div className="admin-mobile-brand">
          <div className="admin-mobile-logo">B</div>

          <div className="admin-mobile-brand-text">
            <strong>BIMBELKU</strong>

            <small>TIGABINANGA</small>
          </div>
        </div>

        {/* Hamburger */}

        <button
          className="admin-mobile-menu-btn"
          onClick={toggleMenu}
          aria-label="Buka menu"
          aria-expanded={isMenuOpen}
        >
          ☰
        </button>
      </header>

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
